import posthog from 'posthog-js';

let initialized = false;

// CRA's production bundle is a `defer` script, so React can render — and fire
// analytics calls — before PostHog consent has initialised (see
// AnalyticsManager). Buffer those early calls here and flush them once
// initPostHog() actually runs, so nothing gets silently dropped.
const MAX_PENDING_EVENTS = 50;
type PendingEvent = { event: string; properties?: Record<string, unknown> };
let pendingEvents: PendingEvent[] = [];

export function initPostHog(): void {
  if (initialized) return;
  const key = process.env.REACT_APP_POSTHOG_KEY;
  if (!key) return;
  posthog.init(key, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://eu.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    session_recording: {
      maskAllInputs: true,
      maskInputOptions: { password: true, email: true },
    },
  });
  initialized = true;

  const buffered = pendingEvents;
  pendingEvents = [];
  for (const { event, properties } of buffered) {
    posthog.capture(event, properties);
  }
}

export function captureEvent(
  event: string,
  properties?: Record<string, unknown>,
): void {
  if (!initialized) {
    pendingEvents.push({ event, properties });
    if (pendingEvents.length > MAX_PENDING_EVENTS) {
      pendingEvents.shift();
    }
    return;
  }
  posthog.capture(event, properties);
}

export function identifyUser(
  userId: string,
  properties?: Record<string, unknown>,
): void {
  if (!initialized) return;
  posthog.identify(userId, properties);
}

export function resetUser(): void {
  if (!initialized) return;
  posthog.reset();
}
